import { useEffect, useState } from 'react';
import { supabase } from '../../lib/supabase';
import type { ClientTask } from '../../context/ClientContext';

/**
 * The roster query only carries task counts; the focus pane and the
 * preview panel need the actual task list. Read-only fetch per client,
 * same query/mapping the context's detail fetch uses.
 */
export default function useClientTasks(clientId: string | undefined, enabled = true): ClientTask[] {
  const [tasks, setTasks] = useState<ClientTask[]>([]);

  useEffect(() => {
    if (!clientId || !enabled) return;
    let cancelled = false;
    setTasks([]);
    supabase
      .from('client_tasks')
      .select('id, title, status, due_date, assigned_by')
      .eq('client_id', clientId)
      .eq('archived', false)
      .order('created_at', { ascending: false })
      .then(({ data, error }) => {
        if (cancelled || error || !data) return;
        setTasks(
          data.map((task) => ({
            id: task.id,
            title: task.title || 'Untitled Task',
            status: task.status ?? '',
            dueDate: task.due_date,
            assignedBy: task.assigned_by,
          }))
        );
      });
    return () => {
      cancelled = true;
    };
  }, [clientId, enabled]);

  return tasks;
}
